// [Codex 2026-07-16] Kept as a mount-compatible boundary while provider
// connections own Grok credentials. Chat must never start the legacy OAuth path.
export function GrokAuthToastBridge() {
  return null;
}
